import{z}from'zod';var groupTagSchema=z.object({name:z.string()});export{groupTagSchema};